import {
  getDisputeDetailsEndpoint,
  downloadAttachmentSfdcEndpoint,
  scanAttachmentsEndpoint,
  scanStatusAttachmentsEndpoint,
  uploadAttachmentsEndpoint,
  downloadSurchargeEmailEndpoint,
} from "@/config/apiEndPoints";
import {
  APIGEE_CLIENT_KEY_DISPUTE,
  APIGEE_CLIENT_KEY_SFDC,
  APIGEE_CLIENT_KEY_ACCOUNT,
} from "@/config/constant";

//Attachment Scan
/**
 * @description
 * @param {*} ohpDisputeId
 * @param {*} files
 * @param {*} idToken
 * @param renameFiles
 * @returns
 */
const scanForAttachments = (
  ohpDisputeId,
  file,
  idToken,
  renameFiles = false
) => {
  // Form Data Object for storing the file details
  const data = new FormData();
  // Adding the file in the Form Data Object
  data.append("file", file.file, file.file.name);
  return {
    method: "post",
    url: encodeURI(
      `${scanAttachmentsEndpoint(ohpDisputeId)}${
        renameFiles ? `?renameFile=true` : ``
      }`
    ),
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

// Scan Status
/**
 * @description
 * @param {*} documentId
 * @param {*} idToken
 * @returns
 */
const getAttachmentScanStatus = (documentId, idToken) => {
  return {
    method: "get",
    url: `${scanStatusAttachmentsEndpoint(documentId)}`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

/**
 * @description
 * @param {*} documentId
 * @param {*} idToken
 * @returns
 */
const uploadAttachments = (ohpDisputeId, requestObject, idToken) => {
  return {
    method: "post",
    url: `${uploadAttachmentsEndpoint(ohpDisputeId)}`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
    data: requestObject,
  };
};

// Attachments
/**
 * @description
 * @param {*} ohpDisputeId
 * @param {*} files
 * @param isExternal
 * @param {*} idToken
 * @returns
 */
const postAttachments = (ohpDisputeId, files, isExternal = false, idToken) => {
  // Form Data Object for storing the file details
  const data = new FormData();
  // Adding the files in the Form Data Object
  files.forEach((element) => {
    data.append("files", element.file, element.file.name);
  });
  return {
    method: "post",
    url: `${getDisputeDetailsEndpoint(
      ohpDisputeId
    )}/attachments?isExternal=${isExternal}`,
    data,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
      accept: "application/vnd.ohp.dispute.v2+json",
    },
  };
};

const getAttachments = (ohpDisputeId, idToken) => {
  return {
    method: "get",
    url: `${getDisputeDetailsEndpoint(ohpDisputeId)}/attachments`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
      accept: "application/vnd.ohp.dispute.v2+json",
    },
  };
};

const downloadAttachment = (ohpDisputeId, fileName, idToken) => {
  return {
    method: "get",
    url: `${getDisputeDetailsEndpoint(
      ohpDisputeId
    )}/attachment/${encodeURIComponent(fileName)}`,
    responseType: "blob",
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const deleteAttachment = (ohpDisputeId, fileName, idToken) => {
  return {
    method: "delete",
    url: `${getDisputeDetailsEndpoint(
      ohpDisputeId
    )}/attachment/${encodeURIComponent(fileName)}`,
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_DISPUTE,
    },
  };
};

const downloadAttachmentSfdc = (id, idToken) => {
  return {
    method: "get",
    url: downloadAttachmentSfdcEndpoint(id),
    responseType: "blob",
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_SFDC,
    },
  };
};
const downloadSurchargeEmail = (id, idToken) => {
  return {
    method: "get",
    url: downloadSurchargeEmailEndpoint(id),
    responseType: "blob",
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

export default {
  postAttachments,
  getAttachments,
  downloadAttachment,
  deleteAttachment,
  downloadAttachmentSfdc,
  scanForAttachments,
  getAttachmentScanStatus,
  uploadAttachments,
  downloadSurchargeEmail,
};
